import React, { useState } from 'react'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import "react-datepicker/dist/react-datepicker.css";
import { Checkbox, ListItemText, OutlinedInput, Button, FormControl, MenuItem, InputLabel, Box, Select } from '@mui/material';
import { WorkPrefrenceAction } from '../../Redux/action/WorkPrefrenceAction';
import TableHeader from '../Common/TableHeader';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import TimeZoneSelect from '../Common/TimeZoneSelect';

const WorkPrefrence = () => {
    const { userResult } = useSelector((state) => state.Auth);
    const [preferredJobLocation, setPreferredJobLocation] = useState([]);
    const [data, setData] = useState({
        workType: "",
        employmentType: "",
        employmentNature: "",
    });

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [availabilityWeekDays, setAvailabilityWeekDays] = useState({
        Monday: {
            startTime: '',
            endTime: '',
        },
        Tuesday: {
            startTime: '',
            endTime: '',
        },
        Wednesday: {
            startTime: '',
            endTime: '',
        },
        Thursday: {
            startTime: '',
            endTime: '',
        },
        Friday: {
            startTime: '',
            endTime: '',
        },
        Saturday: {
            startTime: '',
            endTime: '',
        },
        Sunday: {
            startTime: '',
            endTime: '',
        },
    });

    const { workType, employmentType, employmentNature, timeZone } = data;

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setPreferredJobLocation(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleTimeChange = (day, key, value) => {
        setAvailabilityWeekDays({
            ...availabilityWeekDays,
            [day]: {
                ...availabilityWeekDays[day],
                [key]: value,
            },
        });
    };

    // console.log('AVAI TIME--', availabilityWeekDays)

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        if (name === "requiredSkills") {
            // Split the comma-separated string into an array
            value = value.split(",").map((requiredSkills) => requiredSkills.trim());
        }
        setData({ ...data, [name]: value });
    };

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const names = [
        'Delhi',
        'Noida (Uttar Pradesh)',
        'Lucknow (Uttar Pradesh)',
        'Gurugram (Haryana)',
        'Hyderabad',
        'Mumbai (Maharashtra)',
        'Chandigarh',
        'Mohali (Punjab)',
        'Bengaluru'
    ];

    const candidateId = userResult?.userid;;
    const dispatch = useDispatch();
    const jobLocation = preferredJobLocation.toString();

    const content = {
		candidateId,
		workType,
		employmentType,
		employmentNature,
		// startDate,
		// endDate,
		timeZone,
		preferredJobLocation,
		// availabilityWeekDays,
	};

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(WorkPrefrenceAction(content));
    };

    return (
        <div>
            <ToastContainer />
            <div className="" style={{ background: "#f1fdff", paddingBottom: "10px" }} >
                <TableHeader heading={'Work Preference'} />
                <div style={{ width: "70%", background: "white", margin: "0 auto", height: "auto", marginBottom: "10px", marginTop: "50px", borderRadius: "6px" }}>
                    <form onSubmit={handleSubmit}>
                        <div style={{ width: "80%", display: "flex", margin: "0 auto", paddingTop: "50px" }}>
                            <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                }}
                            >
                                <Box sx={{ margin: "10px 0px 5px 0px" }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Work Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={workType}
                                            label=" Shifts  Timings "
                                            name="workType"
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="REMOTE">REMOTE</MenuItem>
                                            <MenuItem value="ONSITE">ON-SITE</MenuItem>
                                            <MenuItem value="BOTH">BOTH</MenuItem>
                                            {/* <MenuItem value="NONE">Flexible Time</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </Box>
                                < Box sx={{ margin: "10px 0px 5px 0px" }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Job Preference </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={employmentType}
                                            label=" Shifts  Timings "
                                            name="employmentType"
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="FULL_TIME">FULL_TIME</MenuItem>
                                            <MenuItem value="PART_TIME">PART_TIME</MenuItem>
                                            {/* <MenuItem value="flexibleTime">Flexible Time</MenuItem> */}
                                        </Select>
                                    </FormControl>
                                </Box>
                                < Box sx={{ margin: "10px 0px 5px 0px" }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Job Type</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={employmentNature}
                                            label=" Shifts  Timings "
                                            name="employmentNature"
                                            onChange={handleInputChange}
                                        >
                                            <MenuItem value="PERMANENT">PERMANENT</MenuItem>
                                            <MenuItem value="CONTRACT">CONTRACT</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box>
                                {/* <DatePicker
                                    selected={startDate}
                                    onChange={(date) => setStartDate(date)}
                                    dateFormat="dd-MM-yyy"
                                    placeholderText="  Start Date"
                                    className="custom-datepicker"
                                /> */}
                                {/* <DatePicker
                                    selected={endDate}
                                    onChange={(date) => setEndDate(date)}
                                    dateFormat="dd-MM-yyy"
                                    placeholderText="  End Date"
                                    className="custom-datepicker"
                                /> */}
                                < Box sx={{ margin: "10px 0px 5px 0px" }}>
                                    <TimeZoneSelect />
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-multiple-checkbox-label">Job Location</InputLabel>
                                        <Select
                                            labelId="demo-multiple-checkbox-label"
                                            id="demo-multiple-checkbox"
                                            multiple
                                            value={preferredJobLocation}
                                            onChange={handleChange}
                                            name="preferredJobLocation"
                                            input={<OutlinedInput label="Jobs Locations" />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            {names.map((name) => (
                                                <MenuItem key={name} value={name}>
                                                    <Checkbox checked={preferredJobLocation.indexOf(name) > -1} />
                                                    <ListItemText primary={name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </Box>
                            {/* <Box
                                sx={{
                                    width: "100%",
                                    maxWidth: "100%",
                                    marginLeft: "10%",
                                    marginTop: "14px"
                                }}
                            >
                                {Object.entries(availabilityWeekDays).map(([day, availability]) => (
                                    <div key={day} style={{ marginBottom: "23px" }}>
                                        <h6 style={{ fontWeight: "bold" }}>{day}</h6>
                                        <label style={{ paddingRight: "8px" }}>Start Time:</label>
                                        <input
                                            type="time"
                                            value={availability.startTime}
                                            onChange={(e) => handleTimeChange(day, 'startTime', e.target.value)}
                                        />
                                        <label style={{ paddingRight: "8px", paddingLeft: "8px" }}>End Time:</label>
                                        <input
                                            type="time"
                                            value={availability.endTime}
                                            onChange={(e) => handleTimeChange(day, 'endTime', e.target.value)}
                                        />
                                    </div>
                                ))}
                            </Box> */}
                        </div>
                        <div className='Job_Create'>
                            <Button type="submit" style={{ padding: "8px 23px", background: "#1c6597" }} variant="contained">
                                submit
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default WorkPrefrence